import axiosClient from "../../../../axiosClient"

export default async (data) => {
    const result = await axiosClient.post("/invalidate-client-saved-form-structure", data)

    return result.data
}
